<template>
  <div>
    <fieldset
      :disabled="readonly"
      style="border:0;padding:0;margin:0;min-width:0;"
    >
      <div class="card-body">
        <div class="text-right" v-if="!readonly">
          <form-button :indicator="form.processing()" v-on:clicked="saveDates">
            Update Dates
          </form-button>
        </div>
        <div class="clearfix"></div>
        <hr />

        <fieldset>
          <legend>Liability</legend>
          <liability-type
            :incident="incident"
            :type="liabilityTypeId"
            :readonly="readonly"
          ></liability-type>
        </fieldset>

        <fieldset>
          <legend>Dates</legend>

          <selectlist
            name="claim_type"
            label="Claim Type"
            :options="claim_types"
            v-model="claimTypeId"
            placeholder="Please Select"
            key-name="name"
            :readonly="readonly"
          >
            <div slot="rightBtn" v-if="!readonly">
              <form-button
                :indicator="updatingType"
                v-on:clicked="setClaimType"
              >
                Set Claim Type
              </form-button>
            </div>
          </selectlist>
          <hr />
          <div v-bind:key="index" v-for="(date, index) in available_dates">
            <div class="form-group has-helper">
              <div class="col-md-4">
                <label class="control-label">{{ date.label }}:</label>
                <p class="help-block">Please enter the {{ date.label }}</p>
              </div>
              <div class="col-md-8">
                <datepicker
                  :name="date.name"
                  format="dd/MM/yyyy"
                  :value="getValue(date)"
                  input-class="form-control"
                  v-on:updated="updateValue(date, $event)"
                  v-on:selected="updateValue(date, $event)"
                  :disabled="readonly"
                ></datepicker>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <div class="card-footer text-right" v-if="!readonly">
        <form-button :indicator="form.processing()" v-on:clicked="saveDates">
          Update Dates
        </form-button>
      </div>
    </fieldset>
  </div>
</template>
<script>
import LiabilityType from './../../Shared/LiabilityType.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    claimType: Object,
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    'liability-type': LiabilityType
  },

  data() {
    return {
      liabilityTypeId: null,
      claimTypeId: null,
      updatingType: false,
      available_dates: [],
      claim_types: [],
      loaded: false,
      form: new window.Form({})
    };
  },

  computed: {
    liabilityType() {
      return this.$store.getters['Incident/liabilityType'];
    },

    dates() {
      return this.$store.getters['Incident/dates'];
    }
  },

  mounted() {
    window.Ajax.get('/claim-types')
      .then(response => {
        this.claim_types = response.data;
      })
      .catch(error => {});
  },

  methods: {
    loadDates() {
      window.Ajax.get(
        `/claim-monitoring/${this.incident}/available-dates`
      ).then(response => {
        this.available_dates = response.data;
      });
    },

    setClaimType(alert = true) {
      if (this.readonly) return;
      if (this.claimTypeId !== this.claimType?.name) {
        window
          .swal({
            title: 'Are you sure?',
            text: 'This will remove all currently saved dates',
            type: 'warning',
            showCancelButton: true
          })
          .then(() => {
            window.Ajax.post(`/claim-monitoring/${this.incident}/type`, {
              type: this.claimTypeId
            })
              .then(response => {
                this.$store.commit('Incident/setClaimType', response.data);

                this.available_dates = [];

                window.Ajax.get(
                  `/claim-monitoring/${this.incident}/available-dates`
                )
                  .then(response => {
                    this.available_dates = response.data;

                    this.form.wipe();

                    window.Ajax.delete(
                      `/claim-monitoring/${this.incident}/dates`
                    )
                      .then(response => {
                        if (alert) {
                          window.toastify.success(
                            'Success',
                            'The claim type was updated!'
                          );
                        }
                      })
                      .catch(error => {
                        window.toastify.error(
                          'Error',
                          'Sorry, there was an error updating the claim dates'
                        );
                      });
                  })
                  .catch(err => {
                    window.toastify.error(
                      'Error',
                      'Sorry, there was an error getting the available dates'
                    );
                  });
              })
              .catch(err => {
                window.toastify.error(
                  'Error',
                  'Sorry, there was an error setting the claim type'
                );
              });
          });
      }
    },

    setHireMonitoringDates(dates) {
      dates.forEach(date => {
        this.form.addData(date.date.name, date.value);
      });
    },

    enableDates() {
      this.loaded = true;
    },

    getValue(date) {
      if (this.form.hasData(date.name)) {
        return window.DateManager.format(this.form.getData(date.name));
      }
    },

    updateValue(date, $event) {
      this.form.addData(date.name, $event);
    },

    saveDates() {
      if (this.readonly) return;
      this.form
        .post(`/claim-monitoring/${this.incident}/dates`)
        .then(response => {
          window.toastify.success(
            'Saved!',
            'The dates were saved successfully!'
          );
        })
        .catch(error => {});
    }
  },

  watch: {
    claimType: {
      handler(value) {
        this.claimTypeId = value?.name;

        this.loadDates();
      },
      immediate: true
    },

    liabilityType: {
      handler(value) {
        this.liabilityTypeId = value ? value.identifier : '';
      },
      immediate: true
    },

    dates: {
      handler(value) {
        this.setHireMonitoringDates(value);
        this.enableDates();
      },
      immediate: true
    }
  }
};
</script>
